
module.exports = [() => (time, group) => {
  if (parseInt(moment().tz(moment.tz.guess()).format('Z')) !== group.timezone.utcOffset) {
    return moment(time).tz(group.timezone.name).format('HH:mm z');
  }
  return moment(time).format('HH:mm');
}];



// WEBPACK FOOTER //
// ./main/filters/timezone-format-filter.js